import BaseNotificationHandler from './baseHandler';
import i18n from '../../i18n';

class PostDeletedByAdminHandler extends BaseNotificationHandler {
  getIcon() {
    return "🛡️";
  }

  getMainText(notification, parsedData) {
    return parsedData.message
      || notification.message
      || i18n.t('notifications.postDeletedByAdmin.mainText', 'Your post was deleted by moderation');
  }

  getDetails(notification, parsedData) {
    // Prefer translated reason labels sent by backend
    const reasonLabels = parsedData.reason_labels;
    const reasons = parsedData.reasons;

    if (reasonLabels && typeof reasonLabels === 'object' && Object.keys(reasonLabels).length > 0) {
      const labels = Object.values(reasonLabels);
      if (labels.length === 1) {
        return [labels[0]];
      }
      const text = i18n.t(
        'notifications.postDeletedByAdmin.reasonsCount',
        '{{count}} reasons: {{reasons}}',
        { count: labels.length, reasons: labels.join(', ') }
      );
      return [text.length > 80 ? text.substring(0, 80) + '…' : text];
    }

    // Fallback: raw reasons array
    if (Array.isArray(reasons) && reasons.length > 0) {
      const labels = reasons.map((r) => i18n.t(`reportReasons.${r}`, r));
      if (labels.length === 1) {
        return [labels[0]];
      }
      const text = i18n.t(
        'notifications.postDeletedByAdmin.reasonsCount',
        '{{count}} reasons: {{reasons}}',
        { count: labels.length, reasons: labels.join(', ') }
      );
      return [text.length > 80 ? text.substring(0, 80) + '…' : text];
    }

    // Legacy single-string reason
    const reason = parsedData.reason || notification.reason;
    if (reason) {
      const truncated = reason.length > 80 ? reason.substring(0, 80) + '…' : reason;
      return [truncated];
    }

    return [i18n.t('notifications.postDeletedByAdmin.noReason', 'No reason provided.')];
  }

  handleClick(notification, parsedData, navigate, onClose) {
    window.dispatchEvent(
      new CustomEvent('open-post-deleted-modal', {
        detail: {
          reasons: parsedData.reasons || null,
          reason: parsedData.reason || null,
          reason_labels: parsedData.reason_labels || null,
        },
      })
    );
    if (onClose) onClose();
    return true;
  }
}

export default PostDeletedByAdminHandler;
